export class OrderGroupModel {
  constructor() {
    this.customer = {
      address: {},
    };
    this.orders = [];
    this.payment = {};
    this.tracking = null;
  }
};